import { useMemo } from 'react';

import { useMappingsState } from '../providers/BulkConfigureContextProvider.tsx';
import type { FieldMetadata } from '../__types__/apiUtils.ts';

// These fields are always populated by bulk create so they don't need to be explicitly mapped
export const defaultRequiredFields: string[] = [
	'description',
	'issuetype',
	'project',
	'summary',
	'reporter',
];

/**
 * @returns Required fields that have not been mapped to a column in the bulk configure view
 */
export const useGetUnmappedRequiredFields = (): FieldMetadata[] => {
	const { columnToFieldMappings, optionsIssueTypeFields } = useMappingsState();

	return useMemo(() => {
		const mappedFieldIds: Set<string> = new Set(
			columnToFieldMappings
				?.map((mapping) => mapping.field?.fieldId)
				.filter((fieldId: string | undefined): fieldId is string => fieldId !== undefined),
		);
		return (optionsIssueTypeFields ?? []).filter(
			(field) =>
				field.required &&
				!mappedFieldIds.has(field.fieldId) &&
				!defaultRequiredFields.includes(field.key),
		);
	}, [columnToFieldMappings, optionsIssueTypeFields]);
};
